<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo4.png', style='height: auto;width: 200px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cobros
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.metodo"
                            prepend-inner-icon="description"
                            label="Método de pago:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.titular'
                            readonly
                            v-model="form.titular"
                            prepend-inner-icon="description"
                            label="Titular:")
                            
                            v-select(outline
                            readonly
                            :items='itemsF'
                            multiple
                            v-model="form.facturas"
                            prepend-inner-icon="description"
                            label="Facturas:")

                            v-text-field(outline
                            readonly
                            v-model="form.fechaP"
                            prepend-inner-icon="description"
                            label="Fecha:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Monto:")
                            
                            v-textarea(outline
                            readonly
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Observación:")

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche')
                              a(:href='ruta + form.bauche' target='_blank')
                                img(:src='ruta + form.bauche')

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='save("A")') Aprobar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs4)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs4 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
                v-date-picker(v-model='date' no-title='' @input='modal = false' dark='')
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#ff6500' style='font-size: 1.70rem;') search
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Cobros
        v-data-table.elevation-1(:headers='headers' :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.fechaC | moment("DD/MM/YYYY") }}
            td {{ props.item.vendedor }}
            td(v-if='props.item.cliente && props.item.cliente.cli_des') {{ props.item.cliente.cli_des }}
            td(v-else) N/A
            td {{ props.item.metodo }}
            td {{ props.item.monto}}
            td {{ props.item.estatus}}
            td.justify-start.layout.px-0
                v-btn.mx-0(v-if='mod' icon, @click='editItem(props.item)', style='margin-top: -7px;')
                    v-icon(color='teal') edit
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "Cobros",
  data: vm => ({
    ruta: server + ":" + port,
    loading: false,
    dialog4: false,
    itemsF: [],
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
        titular: "",
        vendedor: "",
        cliente: {},
        facturas: [],
        monto: null,
        descripcion: "",
        bauche: "",
        metodo: "",
        observacion: "",
        estatus: "",
        fechaP: "",
        fechaC: ""
    },
    dialog: false,
    resultados: [],
    headers: [
      { text: "Fecha", value: "fechaC" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Cliente", value: "cliente.cli_des" },
      { text: "Método", value: "metodo" },
      { text: "Monto", value: "monto" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    defaultForm: {
        titular: "",
        vendedor: "",
        cliente: {},
        facturas: [],
        monto: null,
        descripcion: "",
        bauche: "",
        metodo: "",
        observacion: "",
        estatus: "",
        fechaP: "",
        fechaC: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webtendencia.permisos.length; i++) {
        if (this.$store.state.webtendencia.permisos[i].ruta === "Cobros") {
          for (
            let j = 0;
            j < this.$store.state.webtendencia.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webtendencia.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webtendencia.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webtendencia.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true
      Api.get("cobros?fecha="+this.date)
      .then(res => {
        this.dialog4 = false
        this.resultados = [];
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let i = 0; i < el.facturas.length; i++) {
              const el2 = el.facturas[i];
              if (typeof el2 === "string") fact = JSON.parse(el2)
            }
            el.facturas = fact
            this.resultados.push(el)
          }
        }
      }).catch(err=>{
        console.log(err)
        this.dialog4 = false
      })
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      Api.get("cobros?fecha="+this.date).then(res => {
        this.resultados = []
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let i = 0; i < el.facturas.length; i++) {
              const el2 = el.facturas[i];
              if (typeof el2 === "string") fact = JSON.parse(el2)
            }
            el.facturas = fact
            this.resultados.push(el)
          }
        }
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog = true;
    },
    save(item) {
      this.loading = true;
      let info = {
        _id: this.form._id,
        estatus: (item === "A") ? "Aprobado" : "Rechazado"
      }
      Api.put("cobros", info)
          .then(() => {
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
            this.buscarFecha();
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
      });
    }
  }
};
</script>
<style lang="scss">
</style>
